<template>
	<section class="AdminPage AdminDashboardPage">
		<div class="Card">
			<ApexChart type="area" height=160 :options="grippRequestChartOptions" :series="gripprequests.series" />
		</div>
		<TableCountsCard :values="tablecounts" />
	</section>
</template>

<script>
	import { mapState, mapActions } from 'vuex';
	import ApexChart from 'vue-apexcharts';
	import TableCountsCard from '@/components/TableCountsCard';

	export default {
		name: 'AdminDashboard',

		components: {
			ApexChart,
			TableCountsCard,
		},

		computed: {
			...mapState('statistic', {
				gripprequests: 'gripprequests',
				tablecounts: 'tablecounts',
			}),

			grippRequestChartOptions() {
				return {
					chart: {
						sparkline: {
							enabled: true
						},
					},
					stroke: {
						curve: 'straight'
					},
					fill: {
						opacity: 0.3
					},
					xaxis: {
						crosshairs: {
							width: 1
						},
						categories: this.gripprequests.categories,
					},
					yaxis: {
						min: 0,
					},
					title: {
						text: this.gripprequests.total,
						offsetX: 0,
						style: {
							fontSize: '24px',
							cssClass: 'apexcharts-yaxis-title'
						}
					},
					subtitle: {
						text: 'Gripp API verbindingen',
						offsetX: 0,
						style: {
							fontSize: '14px',
							cssClass: 'apexcharts-yaxis-title'
						}
					}
				};
			},
		},

		mounted() {
			this.fetchGrippRequests();
			this.fetchTableCounts();
			this.interval = setInterval(() => {
				this.fetchGrippRequests();
			}, 1000*60*5); // 5 minuten
		},

		destroyed() {
			clearInterval(this.interval);
		},

		methods: {
			...mapActions({
				fetchGrippRequests: 'statistic/fetchGrippRequests',
				fetchTableCounts: 'statistic/fetchTableCounts',
			}),
		}
	};
</script>
